import { apiFetch } from "../http";
const getErrorMessage = (data, fallback) => {
    if (!data)
        return fallback;
    return data.error || data.detail || data.message || fallback;
};
const buildQueryString = (params) => {
    const search = new URLSearchParams();
    if (params.campaignId !== null && params.campaignId !== undefined && String(params.campaignId).trim() !== "") {
        search.set("campaign_id", String(params.campaignId));
    }
    if (params.page !== null && params.page !== undefined) {
        search.set("page", String(params.page));
    }
    if (params.pageSize !== null && params.pageSize !== undefined) {
        search.set("page_size", String(params.pageSize));
    }
    if (Array.isArray(params.states) && params.states.length > 0) {
        const states = params.states.map((state) => String(state !== null && state !== void 0 ? state : "").trim()).filter(Boolean);
        if (states.length > 0) {
            search.set("states", states.join(","));
        }
    }
    if (typeof params.subId === "string" && params.subId.trim() !== "") {
        search.set("sub_id", params.subId.trim());
    }
    if (typeof params.dateFrom === "string" && params.dateFrom.trim() !== "") {
        search.set("date_from", params.dateFrom.trim());
    }
    if (typeof params.dateTo === "string" && params.dateTo.trim() !== "") {
        search.set("date_to", params.dateTo.trim());
    }
    const query = search.toString();
    return query ? `?${query}` : "";
};
const buildTravelpayoutsBookingsPath = (travelPlanId) => {
    const normalizedTravelPlanId = String(travelPlanId !== null && travelPlanId !== void 0 ? travelPlanId : "").trim();
    if (!normalizedTravelPlanId) {
        return "/external_services/api/travelpayouts/bookings/";
    }
    return `/external_services/api/travelpayouts/bookings/${encodeURIComponent(normalizedTravelPlanId)}/`;
};
export async function syncTravelpayoutsBookings(params) {
    var _a, _b, _c;
    const body = {
        ...(params.payload.campaign_id !== null &&
            params.payload.campaign_id !== undefined &&
            String(params.payload.campaign_id).trim() !== ""
            ? { campaign_id: params.payload.campaign_id }
            : {}),
        ...(typeof params.payload.sub_id === "string" && params.payload.sub_id.trim() !== ""
            ? { sub_id: params.payload.sub_id.trim() }
            : {}),
        ...(typeof params.payload.date_from === "string" && params.payload.date_from.trim() !== ""
            ? { date_from: params.payload.date_from.trim() }
            : {}),
        ...(typeof params.payload.date_to === "string" && params.payload.date_to.trim() !== ""
            ? { date_to: params.payload.date_to.trim() }
            : {}),
        ...(Array.isArray(params.payload.states) && params.payload.states.length > 0
            ? {
                states: params.payload.states
                    .map((state) => String(state !== null && state !== void 0 ? state : "").trim())
                    .filter(Boolean),
            }
            : {}),
        fetch_all: (_a = params.payload.fetch_all) !== null && _a !== void 0 ? _a : true,
        limit: (_b = params.payload.limit) !== null && _b !== void 0 ? _b : 10000,
        persist: (_c = params.payload.persist) !== null && _c !== void 0 ? _c : true,
    };
    const data = await apiFetch(buildTravelpayoutsBookingsPath(params.travelPlanId), {
        baseUrl: params.baseUrl,
        token: params.token,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
    });
    if ((data === null || data === void 0 ? void 0 : data.success) === false) {
        throw new Error(getErrorMessage(data, "Failed to sync Travelpayouts bookings"));
    }
    return data;
}
export async function getTravelpayoutsBookings(params) {
    const query = buildQueryString(params);
    const data = await apiFetch(`${buildTravelpayoutsBookingsPath(params.travelPlanId)}${query}`, {
        baseUrl: params.baseUrl,
        token: params.token,
        method: "GET",
    });
    if ((data === null || data === void 0 ? void 0 : data.success) === false) {
        throw new Error(getErrorMessage(data, "Failed to fetch Travelpayouts bookings"));
    }
    return data;
}
